import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["role", "tabindex"];
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "image-skeleton skeleton-base skeleton-shimmer",
    role: "status",
    "aria-label": "Carregando avatar do usuário"
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { redirectToUserProfile } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AvatarCard',
    props: {
        avatarException: {},
        renderBorder: { type: Boolean },
        userId: {},
        renderLoadingState: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const isClickable = computed(() => Boolean(props.userId));
        const handleClick = (event) => {
            if (!isClickable.value)
                return;
            event.stopPropagation();
            redirectToUserProfile(props.userId);
        };
        const handleKeydown = (event) => {
            if (!isClickable.value)
                return;
            if (event.key !== 'Enter' && event.key !== ' ')
                return;
            event.preventDefault();
            event.stopPropagation();
            redirectToUserProfile(props.userId);
        };
        const store = useStore();
        const renderComponentBorder = computed(() => Boolean(props.renderBorder && avatarRendered.value));
        const avatarExceptionReference = computed(() => props?.avatarException);
        const avatarData = computed(() => store.getters.getAvatarData);
        const avatarStyle = computed(() => avatarExceptionReference.value?.avatar_style || avatarData.value?.avatar_style);
        const accessoriesType = computed(() => avatarExceptionReference.value?.accessories_type || avatarData.value?.accessories_type);
        const clotheColor = computed(() => avatarExceptionReference.value?.clothe_color || avatarData.value?.clothe_color);
        const clotheType = computed(() => avatarExceptionReference.value?.clothe_type || avatarData.value?.clothe_type);
        const eyeType = computed(() => avatarExceptionReference.value?.eye_type || avatarData.value?.eye_type);
        const eyebrowType = computed(() => avatarExceptionReference.value?.eyebrow_type || avatarData.value?.eyebrow_type);
        const facialHairColor = computed(() => avatarExceptionReference.value?.facial_hair_color || avatarData.value?.facial_hair_color);
        const facialHairType = computed(() => avatarExceptionReference.value?.facial_hair_type || avatarData.value?.facial_hair_type);
        const hairColor = computed(() => avatarExceptionReference.value?.hair_color || avatarData.value?.hair_color);
        const mouthType = computed(() => avatarExceptionReference.value?.mouth_type || avatarData.value?.mouth_type);
        const skinColor = computed(() => avatarExceptionReference.value?.skin_color || avatarData.value?.skin_color);
        const topType = computed(() => avatarExceptionReference.value?.top_type || avatarData.value?.top_type);
        const hatColor = computed(() => avatarExceptionReference.value?.hat_color || avatarData.value?.hat_color);
        const graphicType = computed(() => avatarExceptionReference.value?.graphic_type || avatarData.value?.graphic_type);
        const avatarURL = computed(() => {
            let URL = 'https://avataaars.io/?';
            avatarStyle.value && (URL += `avatarStyle=Transparent&`);
            topType.value && (URL += `topType=${topType.value}&`);
            accessoriesType.value && (URL += `accessoriesType=${accessoriesType.value}&`);
            facialHairType.value && (URL += `facialHairType=${facialHairType.value}&`);
            facialHairColor.value && (URL += `facialHairColor=${facialHairColor.value}&`);
            clotheType.value && (URL += `clotheType=${clotheType.value}&`);
            clotheColor.value && (URL += `clotheColor=${clotheColor.value}&`);
            eyeType.value && (URL += `eyeType=${eyeType.value}&`);
            eyebrowType.value && (URL += `eyebrowType=${eyebrowType.value}&`);
            mouthType.value && (URL += `mouthType=${mouthType.value}&`);
            skinColor.value && (URL += `skinColor=${skinColor.value}&`);
            hairColor.value && (URL += `hairColor=${hairColor.value}&`);
            hatColor.value && (URL += `hatColor=${hatColor.value}&`);
            graphicType.value && (URL += `graphicType=${graphicType.value}&`);
            return URL;
        });
        const avatarRendered = ref(false);
        const renderSkeleton = computed(() => Boolean(props.renderLoadingState && !avatarRendered.value));
        const setAvatarAsRendered = () => {
            avatarRendered.value = true;
        };
        watch(avatarURL, () => {
            if (!props.renderLoadingState)
                return;
            avatarRendered.value = false;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    renderComponentBorder.value && 'image-border',
                    isClickable.value && 'cursor-pointer',
                    'w-100 d-flex align-items-center justify-content-center image-wrapper overflow-hidden bg-white h-100'
                ]),
                role: isClickable.value ? 'button' : undefined,
                tabindex: isClickable.value ? 0 : undefined,
                onClick: handleClick,
                onKeydown: handleKeydown
            }, [
                _withDirectives(_createElementVNode("img", {
                    onLoad: setAvatarAsRendered,
                    onError: setAvatarAsRendered,
                    src: avatarURL.value,
                    alt: "Imagem do Avatar Customizável do Usuário"
                }, null, 40, _hoisted_2), [
                    [_vShow, !renderSkeleton.value]
                ]),
                (renderSkeleton.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                    : _createCommentVNode("", true)
            ], 42, _hoisted_1));
        };
    }
});
